
<div class="main-black border-radius-bottom white-box m-0 page-content" [class.tab-mode]="isTabMode">
	<div class="page-header px-4">
		<a [href]="siteURL" target="_blank"><img src="/sctportal/images/BRM/brm-logo-vertical.png" alt="charglink BRM"></a>
		<div class="horizontal-line mx-4">
		</div>
		<h1>{{'charglink_brm.title' | translate}}</h1>
	</div>

	<div class="page-container p-4">
		<div class="mb-3 d-flex flex-wrap toolbar-row justify-content-between align-items-center">
			<h3 class="ready-to-use">{{"charglink_brm.ready_to_use" | translate}}</h3>
			<button class="btn btn-primary" *ngIf="!isTabMode" (click)="toggleBuzzer()">{{(buzzerEnabled ? 'charglink_brm.disable_buzzer' : 'charglink_brm.enable_buzzer') | translate}}</button>
		</div>

		<div class="d-flex justify-content-around flex-wrap groups-container" *ngIf="!isExpiredToken">
			<div class="group-container" *ngFor="let group of groups; trackBy: trackByGroup; let i = index">
				<!-- group with at least one Ready to Pick battery -->
				<div class="group-box mx-3" [ngClass]="{'animated': group.hasChanged,'show': group.locations.length, 'hide': !group.locations.length}" [style.--index]="groups.length - i">
					<div class="header">
						<img src="/sctportal/images/BRM/check.png" alt="ready-to-use" class="status-image">
						<h4 class="group-name">{{group.name}}</h4>
					</div>
					<div class="ready-list">
						<div class="ready-item" *ngFor="let location of group.displayLocations">
							<span class="ready-badge">
								<svg class="ready-badge-icon" viewBox="0 0 16 16" aria-hidden="true">
									<circle cx="8" cy="8" r="6.8" fill="none" stroke="currentColor" stroke-width="1.5"></circle>
									<path d="M4.9 8.3l2.1 2.1 4.2-4.4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
								</svg>
								{{'charglink_brm.ready_badge' | translate}}
							</span>
							<span class="location">{{location}}</span>
						</div>
					</div>
					<img src="/sctportal/images/BRM/public_battery_on.png" alt="device" class="device-image">
				</div>

				<!-- group with no Ready to Pick battery -->
				<div class="group-box without-location mx-3" [ngClass]="{'animated': group.hasChanged, 'show': !group.locations.length, 'hide': group.locations.length}" [style.--index]="groups.length - i">
					<div class="header">
						<img src="/sctportal/images/BRM/warning.png" alt="not-ready-to-use" class="status-image">
					</div>
					<p class="empty-message">{{'charglink_brm.not_ready_to_use' | translate:{"groupName": group.name} }}</p>
					<img src="/sctportal/images/BRM/public_battery_off.png" alt="device" class="device-image">
				</div>
			</div>
		</div>


		<div *ngIf="isExpiredToken" class="alert alert-danger" role="alert">
			<span>{{'charglink_brm.expired_token' | translate}}</span>
		</div>
	</div>
</div>
